import type { ColDef, ICellRendererParams } from 'ag-grid-community';
import { Tooltip } from '@mui/material';
import { DurationCell } from './components/cells/DurationCell';
import { HorizonsChips } from './components/cells/HorizonsChips';
import { RowsTriple } from './components/cells/RowsTriple';
import { RunStatusBadge } from './components/cells/RunStatusBadge';
import { StartedAtCell } from './components/cells/StartedAtCell';
import type { ForecastRun } from './schema';

export function buildForecastRunsColumns(): ColDef<ForecastRun>[] {
  return [
    {
      field: 'id',
      headerName: 'ID',
      width: 90,
      pinned: 'left',
      lockPinned: true,
      cellRenderer: (p: ICellRendererParams<ForecastRun>) =>
        p.data ? (
          <span className="font-mono text-[12.5px] text-foreground-muted">
            {p.data.id}
          </span>
        ) : null,
    },
    {
      colId: 'status',
      field: 'status',
      headerName: 'Status',
      width: 130,
      sortable: true,
      cellRenderer: RunStatusBadge,
    },
    {
      field: 'metric',
      headerName: 'Metric',
      width: 110,
      cellRenderer: (p: ICellRendererParams<ForecastRun>) =>
        p.data ? (
          <span className="text-[12px] font-semibold uppercase tracking-wider text-foreground">
            {p.data.metric}
          </span>
        ) : null,
    },
    {
      field: 'horizons',
      headerName: 'Horizons',
      width: 200,
      cellRenderer: HorizonsChips,
    },
    {
      colId: 'started',
      field: 'startedAt',
      headerName: 'Started',
      width: 220,
      sortable: true,
      cellRenderer: StartedAtCell,
    },
    {
      headerName: 'Duration',
      width: 130,
      cellRenderer: DurationCell,
    },
    {
      headerName: 'Rows in → features → forecast',
      width: 240,
      cellRenderer: RowsTriple,
    },
    {
      field: 'errorMessage',
      headerName: 'Error',
      flex: 1,
      minWidth: 200,
      cellRenderer: (p: ICellRendererParams<ForecastRun>) => {
        const msg = p.data?.errorMessage;
        if (!msg) return <span className="text-border-strong">—</span>;
        return (
          <Tooltip title={msg} arrow placement="top-start">
            <span className="block truncate text-[13px] text-danger">{msg}</span>
          </Tooltip>
        );
      },
    },
  ];
}
